module.exports = __webpack_public_path__ + "503253222f20d8c8415ad2b39618684d.svg";